import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout/layout.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ChatInputComponent } from './chat-input/chat-input.component';
import { ChatContainerComponent } from './chat-container/chat-container.component';
import { YouChatLogComponent } from './you-chat-log/you-chat-log.component';
import { ContenteditableModule } from '../contenteditable/contenteditable.module';
import { SharedModule } from 'app/components/shared.module';
import { EmojiPickerModule } from '../emoji-picker/emoji-picker.module';
import { DnEmojiService } from 'app/_service/dn-emojis/emoji.service';
import { EmojiPickerService } from '../emoji-picker/emoji-picker.service';
import { DnDialogModule } from '../dn-dialog/dn-dialog.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from 'app/_pipes/pipes.module';
import { PictureViewerModule } from '../picture-viewer/picture-viewer.module';
import { RouterModule } from '@angular/router';


const components = [
  LayoutComponent,
  SidebarComponent,
  ChatInputComponent,
  YouChatLogComponent,
  ChatContainerComponent,
];

// export const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
//   suppressScrollX: true,
//   wheelPropagation: false,
// };
@NgModule({
  declarations: [
    ...components
  ],
  imports: [
    CommonModule,
    //PerfectScrollbarModule,
    ContenteditableModule,
    SharedModule,
    EmojiPickerModule,
    DnDialogModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    PictureViewerModule,
    RouterModule,
  ],
  exports: [
    ...components
  ],
  providers: [
    // {
    //   provide: PERFECT_SCROLLBAR_CONFIG,
    //   useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    // },
    DnEmojiService,
    EmojiPickerService,
  ],
  // entryComponents: [
  //   LayoutComponent
  // ]
})
export class YouChatModule { }
